/** GLOBAL APP FILESYSTEM */
import {File, FILE_CATEGORY, FileSystem} from '@interfaces/interfaces';

export const FS_PATH_MAPPING = {
  ROOT: 'system',
  APPLICATION: 'applications',
  DESKTOP: 'desktop',
  UTILITIES: 'utilities',
  GAMES: 'Super Position EP',
  OTHERS: 'Super Position EP',
  INFO: 'info',
  SYSTEM: 'system',
  PROJECTS: 'Music',
  SOCIAL: 'social'
  
};

export const fs: FileSystem = new FileSystem(
  FS_PATH_MAPPING.ROOT,
  {
    system: FS_PATH_MAPPING.SYSTEM,
    info: FS_PATH_MAPPING.INFO,
	others: FS_PATH_MAPPING.OTHERS,
    projects: FS_PATH_MAPPING.PROJECTS,
    social: FS_PATH_MAPPING.SOCIAL,
    desktop: FS_PATH_MAPPING.DESKTOP,
    utilities: FS_PATH_MAPPING.UTILITIES,
  }
);

export const FILES: File[] = [
  {
    properties: {
      name: 'Super Position (EP)',
      alt: 'My latest EP',
      category: FILE_CATEGORY.LINK,
      data: {url: 'https://xfallen.bandcamp.com/album/ep-super-position'},
      icon: 'unity',
      iconContrast: 'unity'
    },
    fs: {
      paths: [fs.getPath(FS_PATH_MAPPING.PROJECTS)],
      root: fs.getPath(FS_PATH_MAPPING.PROJECTS)
    }
  },
  
{
    properties: {
      name: '01. Intangible.Wav',
      alt: 'ProdByFallen - Intangible Wav',
      category: FILE_CATEGORY.LINK,
      data: {url: 'https://xfallen.bandcamp.com/track/intangible-wav'},
      icon: 'unity',
      iconContrast: 'unity'
    },
    fs: {
      paths: [fs.getPath(FS_PATH_MAPPING.OTHERS)],
      root: fs.getPath(FS_PATH_MAPPING.OTHERS)
    }
  },
  {
    properties: {
      name: '02. Super Position (ft. Archaeologist)',
      alt: 'ProdByFallen - Super Position (ft. Archaeologist)',
      category: FILE_CATEGORY.LINK,
      data: {url: 'https://xfallen.bandcamp.com/track/super-position-ft-archaeologist'},
      icon: 'unity',
      iconContrast: 'unity'
    },
    fs: {
      paths: [fs.getPath(FS_PATH_MAPPING.OTHERS)],
      root: fs.getPath(FS_PATH_MAPPING.OTHERS)
	  }
  },
  {
    properties: {
      name: '03. Levels',
      alt: 'ProdByFallen - Levels',
      category: FILE_CATEGORY.LINK,
      data: {url: 'https://xfallen.bandcamp.com/track/levels'},
      icon: 'unity',
      iconContrast: 'unity'
    },
    fs: {
      paths: [fs.getPath(FS_PATH_MAPPING.OTHERS)],
      root: fs.getPath(FS_PATH_MAPPING.OTHERS)
	  }
  },
  {
    properties: {
      name: '04. Game Over',
      alt: 'ProdByFallen - Game Over',
      category: FILE_CATEGORY.LINK,
      data: {url: 'https://xfallen.bandcamp.com/track/game-over-chipstep'},
      icon: 'unity',
      iconContrast: 'unity'
    },
    fs: {
      paths: [fs.getPath(FS_PATH_MAPPING.OTHERS)],
      root: fs.getPath(FS_PATH_MAPPING.OTHERS)
	  }
  },
  {
    properties: {
      name: '05. Malloc()',
      alt: 'ProdByFallen - Malloc()',
      category: FILE_CATEGORY.LINK,
      data: {url: 'https://xfallen.bandcamp.com/track/malloc'},
      icon: 'unity',
      iconContrast: 'unity'
    },
    fs: {
      paths: [fs.getPath(FS_PATH_MAPPING.OTHERS)],
      root: fs.getPath(FS_PATH_MAPPING.OTHERS)
	  }
  },
  {
    properties: {
      name: 'TribalRose - Around (2021 Demo)',
      alt: '2021 version of my demo Around',
      category: FILE_CATEGORY.LINK,
      data: {url: 'https://www.youtube.com/watch?v=LbHZgpSas_Y'},
      icon: 'youtube',
      iconContrast: 'youtube'
    },
    fs: {
      paths: [fs.getPath(FS_PATH_MAPPING.PROJECTS)],
      root: fs.getPath(FS_PATH_MAPPING.PROJECTS)
    }
  },
  {
    properties: {
      name: 'TribalRose - Everything EP',
      alt: 'My Guitar Demos',
      category: FILE_CATEGORY.LINK,
      data: {url: 'https://TribalRose.bandcamp.com'},
      icon: 'unity',
      iconContrast: 'unity'
    },
    fs: {
      paths: [fs.getPath(FS_PATH_MAPPING.PROJECTS)],
      root: fs.getPath(FS_PATH_MAPPING.PROJECTS)
    }
  },
  {
    properties: {
      name: 'Chiptune Remixes',
      alt: 'My Youtube Channel',
      category: FILE_CATEGORY.LINK,
      data: {url: 'https://Youtube.com/xFallenDemon99x/'},
      icon: 'youtube',
      iconContrast: 'youtube'
    },
    fs: {
      paths: [fs.getPath(FS_PATH_MAPPING.PROJECTS)],
      root: fs.getPath(FS_PATH_MAPPING.PROJECTS)
    }
  },

  {
    properties: {
      name: 'YouTube',
      alt: 'My Main Youtube Channel',
      category: FILE_CATEGORY.LINK,
      data: {url: 'https://www.youtube.com/xFallenDemon99x'},
      icon: 'youtube',
      iconContrast: 'youtube'
    },
    fs: {
      paths: [
        fs.getPath(FS_PATH_MAPPING.SOCIAL),
        fs.getPath(FS_PATH_MAPPING.DESKTOP)],
      root: fs.getPath(FS_PATH_MAPPING.SOCIAL)
    }
  },
  {
    properties: {
      name: 'Bandcamp',
      alt: 'ProdByFallen on Bandcamp',
      category: FILE_CATEGORY.LINK,
      data: {url: 'https://xFallen.bandcamp.com'},
      icon: 'unity',
      iconContrast: 'unity'
    },
    fs: {
      paths: [
        fs.getPath(FS_PATH_MAPPING.SOCIAL),
        fs.getPath(FS_PATH_MAPPING.DESKTOP)],
      root: fs.getPath(FS_PATH_MAPPING.SOCIAL)
    }
  },
  {
    properties: {
      name: 'Spotify',
      alt: 'ProdByFallen on Spotify',
      category: FILE_CATEGORY.LINK,
      data: {url: 'https://open.spotify.com/artist/58I7icWChtlsIQI7mgmfYz'},
      icon: 'devTo',
      iconContrast: 'devTo'
    },
    fs: {
      paths: [fs.getPath(FS_PATH_MAPPING.SOCIAL)],
      root: fs.getPath(FS_PATH_MAPPING.SOCIAL)
    }
  },
  {
    properties: {
      name: 'Linktree',
      alt: 'Stream ProdByFallen',
      category: FILE_CATEGORY.LINK,
      data: {url: 'https://linktr.ee/ProdByFallen'},
      icon: 'linkedin',
      iconContrast: 'linkedin'
    },
    fs: {
      paths: [
        fs.getPath(FS_PATH_MAPPING.SOCIAL),
        fs.getPath(FS_PATH_MAPPING.DESKTOP)],
      root: fs.getPath(FS_PATH_MAPPING.SOCIAL)
    }
  },
  {
    properties: {
      name: 'Twitter',
      alt: 'My Twitter profile',
      category: FILE_CATEGORY.LINK,
      data: {url: 'https://twitter.com/xFD99x'},
      icon: 'twitterIcon',
      iconContrast: 'twitterIcon'
    },
    fs: {
      paths: [
        fs.getPath(FS_PATH_MAPPING.SOCIAL),
        fs.getPath(FS_PATH_MAPPING.DESKTOP)],
      root: fs.getPath(FS_PATH_MAPPING.SOCIAL)
    }
  },
  {
    properties: {
      name: 'Reddit',
      alt: 'My Subreddit',
      category: FILE_CATEGORY.LINK,
      data: {url: 'https://www.reddit.com/r/xFallenDemon99x'},
      icon: 'redditIcon',
      iconContrast: 'redditIcon'
    },
    fs: {
      paths: [fs.getPath(FS_PATH_MAPPING.SOCIAL)],
      root: fs.getPath(FS_PATH_MAPPING.SOCIAL)
    }
  },
  {
    properties: {
      name: 'Facebook',
      alt: 'ProdByFallen on Facebook',
      category: FILE_CATEGORY.LINK,
      data: {url: 'https://facebook.com/ProdByFallen'},
      icon: 'hackernoonIcon',
      iconContrast: 'hackernoonIcon'
    },
    fs: {
      paths: [fs.getPath(FS_PATH_MAPPING.SOCIAL)],
      root: fs.getPath(FS_PATH_MAPPING.SOCIAL)
    }
  },
  {
    properties: {
      name: 'Itch.io',
      alt: 'My itch.io landing page',
      category: FILE_CATEGORY.LINK,
      data: {url: 'https://xFallenDemon99x.itch.io/'},
      icon: 'itch',
      iconContrast: 'itch'
    },
    fs: {
      paths: [
        fs.getPath(FS_PATH_MAPPING.SOCIAL),
        fs.getPath(FS_PATH_MAPPING.DESKTOP)
      ],
      root: fs.getPath(FS_PATH_MAPPING.SOCIAL)
    }
  },
  {
    properties: {
      name: FS_PATH_MAPPING.APPLICATION,
      alt: 'Applications folder',
      category: FILE_CATEGORY.FOLDER,
      icon: 'folderIcon',
      iconContrast: 'folderIcon'
    },
    fs: {
      paths: [
        fs.getPath(FS_PATH_MAPPING.ROOT),
        fs.getPath(FS_PATH_MAPPING.DESKTOP)
      ],
      root: fs.getPath(FS_PATH_MAPPING.APPLICATION)
    }
  },
  {
    properties: {
      name: FS_PATH_MAPPING.PROJECTS,
      alt: 'Music folder',
      category: FILE_CATEGORY.FOLDER,
      icon: 'folderIcon',
      iconContrast: 'folderIcon'
    },
    fs: {
      paths: [fs.getPath(FS_PATH_MAPPING.ROOT), fs.getPath(FS_PATH_MAPPING.DESKTOP)],
      root: fs.getPath(FS_PATH_MAPPING.PROJECTS)
    }
  },
  {
    properties: {
      name: FS_PATH_MAPPING.GAMES,
      alt: 'Super Position EP',
      category: FILE_CATEGORY.FOLDER,
      icon: 'folderIcon',
      iconContrast: 'folderIcon'
    },
    fs: {
      paths: [fs.getPath(FS_PATH_MAPPING.ROOT), fs.getPath(FS_PATH_MAPPING.DESKTOP)],
      root: fs.getPath(FS_PATH_MAPPING.OTHERS)
    }
  },
  {
    properties: {
      name: FS_PATH_MAPPING.SOCIAL,
      alt: 'Socials folder',
      category: FILE_CATEGORY.FOLDER,
      icon: 'folderIcon',
      iconContrast: 'folderIcon'
    },
    fs: {
      paths: [fs.getPath(FS_PATH_MAPPING.ROOT), fs.getPath(FS_PATH_MAPPING.DESKTOP)],
      root: fs.getPath(FS_PATH_MAPPING.SOCIAL)
    }
  }
];
